import React from 'react';
import { connect } from 'react-redux';
import SignUpManualCheckEmail from './SignUpManualCheckEmail';
import SignUpManualUserInfo from './SignUpManualUserInfo';
import { getSignUpManualPreFillInfo, getSignUpManualStep } from '../../reducers';
import BackButton from '../common/BackButton';

interface Props {
    apple: boolean;
    info: any;
    paymentGateway: string;
    step: string;
    checkEmailPost: ({}: {email: string}) => void;
    onLoginClick: () => void;
    registerPost: (data: any) => void;
    showRegister: () => void;
}

class SignUpManual extends React.Component<Props> {
    render() {
        return <div className="container py-4">
            <div>
                <BackButton onBackClick={this.props.showRegister}>
                    <h1 className='title-1 mt-3 mb-5' style={{maxWidth:'60%'}}>Completa tu registro</h1>
                </BackButton>
            </div>
            <div>
                {this.renderContent()}
            </div>
        </div>;
    }

    renderContent() {
        if (this.props.step === "1" && !this.props.apple) {
            return <SignUpManualCheckEmail onSubmit={this.props.checkEmailPost} onLoginClick={this.props.onLoginClick}/>;
        } else {
            return <SignUpManualUserInfo info={this.props.info} onSubmit={this.props.registerPost} apple={this.props.apple} paymentGateway={this.props.paymentGateway} />;
        }
    }
}

const mapStateToProps = state => ({
    info: getSignUpManualPreFillInfo(state),
    step: getSignUpManualStep(state),
});

export default connect(
    mapStateToProps
)(SignUpManual);